import { render, staticRenderFns } from "./AssignedBook.vue?vue&type=template&id=2e0855de&scoped=true&"
import script from "./AssignedBook.vue?vue&type=script&lang=js&"
export * from "./AssignedBook.vue?vue&type=script&lang=js&"
import style0 from "./AssignedBook.vue?vue&type=style&index=0&id=2e0855de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0855de",
  null
  
)

export default component.exports